<template>
  <ul class="navigation">
    <li
      v-for="item in menuItems"
      :key="item"
      :class="{ active: activeItem === item }"
      @click="$emit('active-item', item)"
    >
      {{ item }}
    </li>
  </ul>
</template>
<script>
export default {
  name: 'Navigation',

  props: {
    activeItem: {
      type: String,
      default: 'Activities'
    }
  },

  data() {
    return {
      menuItems: ['Activities', 'Appearance', 'Print/Export']
    };
  }
};
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  margin: 0 0 10px 0;
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 10px;

  li {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    color: #616161;
    padding: 10px;
    border-radius: 10px;
    background-color: #fff;
    transition: all 300ms ease 0ms;
    cursor: pointer;

    &:not(:first-of-type) {
      margin-left: 10px;
    }

    &.active,
    &:hover {
      background-color: #000;
      color: #fff;
    }
  }
}
</style>
